module.exports = __webpack_public_path__ + "static/media/highland.9152178a.png";